import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

import { Button } from "../Button";

export const TabsLink = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const Tabs = [
    {
      label: t("menu.trade"),
      link: "/trades",
      isExternal: false,
      disabled: false,
    },
    {
      label: t("menu.portfolio"),
      link: "/portfolio",
      isExternal: false,
    },
    {
      label: t("menu.leaderboard"),
      link: "/leaderboard",
      isExternal: false,
    },
    {
      label: t("menu.stats"),
      link: "/stats",
      isExternal: false,
    },
    {
      label: t("menu.competitions"),
      link: "/competitions/live",
      isExternal: false,
      disabled: true,
    },
  ];

  const handleRoute = (link: string, isExternal: boolean) => {
    if (isExternal) {
      window.open(link, "_blank");
    } else {
      navigate(link);
    }
  };
  return (
    <StyledTabNavRoot aria-label={t("menu.navigation", "Main navigation")} data-testid="app:header:nav">
      {Tabs.map((tab, index) => {
        const isActive = !tab.disabled && location.pathname.includes(tab.link);
        let testId = `app:header:nav-${tab.link.replace("/", "")}`;
        if (tab.isExternal) {
          testId = "app:header:nav-docs";
        }
        return (
          <Button
            key={index}
            variant={isActive ? "outline" : "soft"}
            onClick={() => !tab.disabled && handleRoute(tab.link, tab.isExternal)}
            data-testid={testId}
            disabled={tab.disabled}
            style={tab.disabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
          >
            {tab.label}
          </Button>
        );
      })}
    </StyledTabNavRoot>
  );
};

const StyledTabNavRoot = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: none;
`;
